// AUTO-GENERATED from content/consumables/*.toml (h2kdb) — do not edit.
// Consumables (lane A, 2026-06-30). Every row is authored in h2kdb TOML; omitted
// fields take the compiler defaults (name = id, stackSize 99, levelRequirement 1, others 0).

export type ConsumableType = 'potion' | 'food' | 'drink' | 'elixir' | 'flask' | 'bandage' | 'scroll' | 'consumable';

export interface ConsumableDataDef {
  id: string;
  name: string;
  consumableType: ConsumableType;
  /** Effect IDs resolved against ABILITY_EFFECT_DATABASE in ability-effects.gen.ts. */
  effects: string[];
  cooldownSec: number;
  durationSec: number;
  stackSize: number;
  levelRequirement: number;
  buyPrice: number;
  sellPrice: number;
  tags?: string[];
}

export const CONSUMABLE_DATABASE: Record<string, ConsumableDataDef> = {
  'bandage': {
    id: 'bandage',
    name: 'Linen Bandage',
    consumableType: 'bandage',
    effects: ['heal_over_time_100'],
    cooldownSec: 0,
    durationSec: 8,
    stackSize: 20,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 3,
  },
  'elixir_of_speed': {
    id: 'elixir_of_speed',
    name: 'Elixir of Speed',
    consumableType: 'elixir',
    effects: ['buff_speed_60'],
    cooldownSec: 0,
    durationSec: 60,
    stackSize: 20,
    levelRequirement: 5,
    buyPrice: 0,
    sellPrice: 25,
  },
  'elixir_of_fortitude': {
    id: 'elixir_of_fortitude',
    name: 'Elixir of Fortitude',
    consumableType: 'elixir',
    effects: ['buff_fortitude_100'],
    cooldownSec: 0,
    durationSec: 60,
    stackSize: 20,
    levelRequirement: 8,
    buyPrice: 0,
    sellPrice: 40,
  },
  'flask_of_the_titans': {
    id: 'flask_of_the_titans',
    name: 'Flask of the Titans',
    consumableType: 'flask',
    effects: ['buff_titans_allstats'],
    cooldownSec: 0,
    durationSec: 1800,
    stackSize: 5,
    levelRequirement: 12,
    buyPrice: 0,
    sellPrice: 200,
    tags: ['flask', 'endgame'],
  },
  'flask_of_the_speed_runner': {
    id: 'flask_of_the_speed_runner',
    name: 'Flask of the Speed Runner',
    consumableType: 'flask',
    effects: ['buff_speed_runner', 'teleport_run_origin'],
    cooldownSec: 0,
    durationSec: 1800,
    stackSize: 1,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 0,
    tags: ['helix', 'runner', 'speedrun', 'non_tradeable'],
  },
  'flask_of_the_slow_runner': {
    id: 'flask_of_the_slow_runner',
    name: 'Flask of the Slow Runner',
    consumableType: 'flask',
    effects: ['buff_slow_runner', 'teleport_run_origin'],
    cooldownSec: 0,
    durationSec: 1800,
    stackSize: 1,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 0,
    tags: ['helix', 'runner', 'balance', 'practice_only', 'non_tradeable'],
  },
  'return_scroll': {
    id: 'return_scroll',
    name: 'Return Scroll',
    consumableType: 'scroll',
    effects: ['teleport_bound_town'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 50,
    tags: ['travel', 'bound_town'],
  },
  'gm_elixir_of_speed': {
    id: 'gm_elixir_of_speed',
    name: 'GM Elixir of Speed',
    consumableType: 'elixir',
    effects: ['buff_speed_60'],
    cooldownSec: 0,
    durationSec: 60,
    stackSize: 20,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 0,
    tags: ['gm', 'qa', 'waking_vault'],
  },
  'gm_elixir_of_fortitude': {
    id: 'gm_elixir_of_fortitude',
    name: 'GM Elixir of Fortitude',
    consumableType: 'elixir',
    effects: ['buff_fortitude_100'],
    cooldownSec: 0,
    durationSec: 60,
    stackSize: 20,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 0,
    tags: ['gm', 'qa', 'waking_vault'],
  },
  'gm_flask_of_the_titans': {
    id: 'gm_flask_of_the_titans',
    name: 'GM Flask of the Titans',
    consumableType: 'flask',
    effects: ['buff_titans_allstats'],
    cooldownSec: 0,
    durationSec: 1800,
    stackSize: 5,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 0,
    tags: ['gm', 'qa', 'waking_vault'],
  },
  'attack_scroll': {
    id: 'attack_scroll',
    name: 'Attack Scroll',
    consumableType: 'scroll',
    effects: ['buff_attack_10'],
    cooldownSec: 0,
    durationSec: 300,
    stackSize: 10,
    levelRequirement: 5,
    buyPrice: 0,
    sellPrice: 50,
  },
  'defense_scroll': {
    id: 'defense_scroll',
    name: 'Defense Scroll',
    consumableType: 'scroll',
    effects: ['buff_defense_10'],
    cooldownSec: 0,
    durationSec: 300,
    stackSize: 10,
    levelRequirement: 5,
    buyPrice: 0,
    sellPrice: 50,
  },
  'experience_scroll': {
    id: 'experience_scroll',
    name: 'Experience Scroll',
    consumableType: 'scroll',
    effects: ['buff_experience_2x'],
    cooldownSec: 0,
    durationSec: 1800,
    stackSize: 5,
    levelRequirement: 8,
    buyPrice: 0,
    sellPrice: 200,
  },
  'red_potion': {
    id: 'red_potion',
    name: 'Red Potion',
    consumableType: 'potion',
    effects: ['restore_health_50'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 5,
  },
  'orange_potion': {
    id: 'orange_potion',
    name: 'Orange Potion',
    consumableType: 'potion',
    effects: ['restore_health_150'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 5,
    buyPrice: 0,
    sellPrice: 15,
  },
  'blue_potion': {
    id: 'blue_potion',
    name: 'Blue Potion',
    consumableType: 'potion',
    effects: ['restore_mana_50'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 10,
  },
  'antidote': {
    id: 'antidote',
    name: 'Antidote',
    consumableType: 'potion',
    effects: ['dispel_poison'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 20,
    levelRequirement: 3,
    buyPrice: 0,
    sellPrice: 10,
  },
  'power_elixir': {
    id: 'power_elixir',
    name: 'Power Elixir',
    consumableType: 'elixir',
    effects: ['restore_health_full', 'restore_mana_full'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 5,
    buyPrice: 0,
    sellPrice: 5000,
  },
  'mana_candy': {
    id: 'mana_candy',
    name: 'Mana Candy',
    consumableType: 'consumable',
    effects: ['restore_mana_30'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 50,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 5,
  },
  'gm_red_potion': {
    id: 'gm_red_potion',
    name: 'GM Red Potion',
    consumableType: 'potion',
    effects: ['restore_health_50'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 0,
    tags: ['gm', 'qa', 'waking_vault'],
  },
  'gm_blue_potion': {
    id: 'gm_blue_potion',
    name: 'GM Blue Potion',
    consumableType: 'potion',
    effects: ['restore_mana_50'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 0,
    tags: ['gm', 'qa', 'waking_vault'],
  },
  'gm_orange_potion': {
    id: 'gm_orange_potion',
    name: 'GM Orange Potion',
    consumableType: 'potion',
    effects: ['restore_health_150'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 0,
    tags: ['gm', 'qa', 'waking_vault'],
  },
  'gm_antidote': {
    id: 'gm_antidote',
    name: 'GM Antidote',
    consumableType: 'potion',
    effects: ['dispel_poison'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 20,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 0,
    tags: ['gm', 'qa', 'waking_vault'],
  },
  'gm_power_elixir': {
    id: 'gm_power_elixir',
    name: 'GM Power Elixir',
    consumableType: 'elixir',
    effects: ['restore_health_full', 'restore_mana_full'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 0,
    tags: ['gm', 'qa', 'waking_vault'],
  },
  'health_potion': {
    id: 'health_potion',
    name: 'Health Potion',
    consumableType: 'potion',
    effects: ['restore_health_70'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 5,
  },
  'greater_health_potion': {
    id: 'greater_health_potion',
    name: 'Greater Health Potion',
    consumableType: 'potion',
    effects: ['restore_health_140'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 5,
    buyPrice: 0,
    sellPrice: 15,
  },
  'potion_major_healing': {
    id: 'potion_major_healing',
    name: 'Major Healing Potion',
    consumableType: 'potion',
    effects: ['restore_health_300'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 15,
    buyPrice: 0,
    sellPrice: 50,
  },
  'mana_potion': {
    id: 'mana_potion',
    name: 'Mana Potion',
    consumableType: 'potion',
    effects: ['restore_mana_70'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 1,
    buyPrice: 0,
    sellPrice: 10,
  },
  'greater_mana_potion': {
    id: 'greater_mana_potion',
    name: 'Greater Mana Potion',
    consumableType: 'potion',
    effects: ['restore_mana_140'],
    cooldownSec: 0,
    durationSec: 0,
    stackSize: 99,
    levelRequirement: 5,
    buyPrice: 0,
    sellPrice: 25,
  },
};

export function getConsumable(id: string): ConsumableDataDef | undefined {
  return CONSUMABLE_DATABASE[id];
}
